import React, { Component, createRef } from "react";
// // Editable
import { withTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { useParams } from "react-router-dom";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import validate from "../../common/validation";
import { Formik, Field, Form, ErrorMessage } from "formik";
import {
  addGraderAssignStockList,
  getUserByRoleId,
  updateGraderAssignStock,
  getUserApi,
  getShapes,
  getInclusion,
  updateGraderStock,
  getProcess,
} from "api";
import * as Yup from "yup";
import {
  categoriTypes,
  status,
  color,
  purity,
  process,
} from "../StaticData.js";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { number } from "prop-types";

class GraderAssignScreen extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      isSubmit: false,
      fillerList: [],
      successTrue: false,
      shapesList: [],
      inclusionList: [],
      processList: [],
      props: props?.location?.query,
      notEditableRows:props?.location?.query?.data?.assignGraderToFillerInWards.map(x => {
        return x.id;
      }),
      stockList:props?.location?.query?.data?.assignGraderToFillerInWards.map(x => {
        return {
          id: x.id,
          weight: x.weight,
          cycle: x.cycle,
          weightType: x.stockGraderInWard.weightType,
          shapeId:
            x.stockGraderInWard.shapeId == null
              ? ""
              : x.stockGraderInWard.shapeId,
          shape:
            x.stockGraderInWard.shape == null
              ? ""
              : x.stockGraderInWard.shape,
          inclusion:
            x.stockGraderInWard.inclusion == null
              ? ""
              : x.stockGraderInWard.inclusion,
          inclusionId:
            x.stockGraderInWard.inclusionId == null
              ? ""
              : x.stockGraderInWard.inclusionId,
          colorId: x.colorId == null ? "" : x.colorId,
          oColorId:
            x.stockGraderInWard.oColorId == null
              ? ""
              : x.stockGraderInWard.oColorId,
          purityId:
            x.stockGraderInWard.purityId == null
              ? ""
              : x.stockGraderInWard.purityId,
          processId: x.process == null ? "" : x.process.name,
          remarks: x.remarks,
          nextRemarks: x.nextRemarks,
          pieces: x.stockDataEntryInWard.pieces,
          srNo: x.stockDataEntryInWard.srNo,
        };
      })
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  validateTable() {
    console.log(this.state.stockList);
    for (let i = 0; i < this.state.stockList.length; i++) {
      let e = this.state.stockList[i];
      if (e.processId == "") {
        return false;
      }
    }

    return true;
  }
  async componentDidMount() {
    const shape = await getShapes();
    if (shape && shape.data) {
      this.setState({
        shapesList: [
          { label: "NONE", value: "" },
          ...shape.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      });
    }
    const process = await getProcess();
    console.log(process)
    if (process && process.data) {
      this.setState({
        processList: [
          { label: "NONE", value: "" },
          ...process.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      });
    }
    const inclusion = await getInclusion();
    if (inclusion && inclusion.data) {
      this.setState({
        inclusionList: [
          { label: "NONE", value: "" },
          ...inclusion.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      });
    }
    const filler = await getUserApi({
      factoryId: this.state.props.data.jangad.factory.id,
      roleId: "ROLE0000003",
    });
    if (filler && filler.data) {
      this.setState({
        fillerList: filler.data.users,
      });
    }

    this.setState({
      stockList: this.state.stockList.map(x => {
        return {
          ...x,
          inclusionId:
            x.inclusionId == null
              ? []
              : this.state.inclusionList.filter(y =>
                  x.inclusionId.includes(y.value)
                ),
        };
      }),
    });
  }

  deleteRow(rowIndex) {
    this.state.stockList.splice(rowIndex, 1);
    this.setState({
      stockList: this.state.stockList,
      notEditableRows: this.state.stockList.map((x, index) => x.id),
    });
  }
  addRow() {
    this.setState({
      stockList: [
        ...this.state.stockList,
        {
          id: this.state.stockList.length + 1,
          categoryId: 1,
          weight: 0,
          weightType: "CT",
          pieces: 0,
          inWardRemarks: "",
          forNextPersonRemarks: "",
          status: "true",
          assignProcess: 0,
        },
      ],
      notEditableRows: [
        ...this.state.notEditableRows,
        this.state.stockList.length + 1,
      ],
    });
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit == 1) {
      let temp = {
        remarks: values.remarks,
        nextRemarks: values.nextRemarks,
        fillerId: values.fillerId,
        assignGraderToFillerInWards: this.state.stockList.map(x => {
          return {
            ...x,
            mainJangadId: this.state.props.data.mainJangadId,
            jangadId: this.state.props.data.jangadId,
            dataEntryStockId: this.state.props.data.dataEntryStockId,
            graderStockId: this.state.props.data.id,
          };
        }),
        cycle: 1,
        mainJangadId: this.state.props.data.mainJangadId,
        jangadId: this.state.props.data.jangadId,
        dataEntryStockId: this.state.props.data.dataEntryStockId,
        graderStockId: this.state.props.data.id,
      };
      const data = await addGraderAssignStockList(temp);
      if (data.success == true) {
        this.setState({
          successTrue: true,
        });
      }
    } else {
      let id = this.state.props.data.id;
      let temp = {
        fillerId: values.fillerId,
        cycle: values.cycle,
        remarks: values.remarks,
        nextRemarks: values.nextRemarks,
        fillerStatus: "P",
        assignGraderToFillerInWards: this.state.stockList,
      };

      // console.log(id, temp)

      const data = await updateGraderAssignStock({ data: temp, id: id });
    }

    // values.stockGraderInWards = this.state.stockList;
    // delete values.partyCode;
    // if (this.state.props.isEdit == 1) {
    //   let id = this.state.props.data.dataEntryStock.graderStocks.reduce(
    //     (prev, current) => {
    //       return prev.cycle > current.cycle ? prev : current;
    //     }
    //   ).id;

    //   console.log(values);

    // } else {
    //   const data = await updateGraderAssignStock(values);
    // }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    document.title = "filler flow";

    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        hidden: true,
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        editable: false,
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        editable: false,
        type: "number",
        editable: false,
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        type: "number",
        editable: false,
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        editable: false,
      },

      {
        dataField: "colorId",
        text: `${this.props.t("Color")}`,
        editable: false,
        editor: {
          type: Type.SELECT,
          options: color,
        },
        formatter: (cell, row) => {
          return color.filter(x => x.value == cell)[0].label;
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
      {
        dataField: "shapeId",
        text: `${this.props.t("Shapes")}`,
        editable: false,
        editor: {
          type: Type.SELECT,
          options: this.state.shapesList,
        },
        formatter: (cell, row) => {
          if (cell == "") {
            return "NONE";
          } else if (
            parseInt(cell) > 0 &&
            this.state.props.isEdit != 1 &&
            cell == row.shape.id
          ) {
            return row.shape.name;
          } else {
            return this.state.shapesList?.filter(x => x.value == cell)[0]
              ?.label;
          }
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
      {
        dataField: "inclusionId",
        text: `${this.props.t("Inclusion")}`,
        editable: false,
        editor: {
          type: Type.SELECT,
          options: this.state.inclusionList,
        },
        formatter: (cell, row) => {
          console.log(row.inclusionId);
          if (row.inclusionId.length && typeof row.inclusionId[0] != "number") {
            let temp = [];
            temp = row.inclusionId.map(x =>
              typeof x == "number" ? x : x.value
            );
            return this.state.inclusionList
              .filter(x => temp.includes(x.value))
              .map(x => (
                <span key={x.value} className="border border-1 px-1 py-1 m-1">
                  {x.label}
                </span>
              ));
          } else {
            return "NONE";
          }
        },
      },

      {
        dataField: "purityId",
        text: `${this.props.t("Purity")}`,
        editable: false,
        editor: {
          type: Type.SELECT,
          options: purity,
        },
        formatter: (cell, row) => {
          return purity.filter(x => x.value == cell)[0].label;
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },

      {
        dataField: "remarks",
        text: `${this.props.t("Inward Remarks")}`,
        editable: false,
      },
      {
        dataField: "nextRemarks",
        text: `${this.props.t("For Next Person Instruction")}`,
      },
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        editor: {
          type: Type.SELECT,
          options: this.state.processList,
        },
        formatter: (cell, row) => {
          console.log(cell)
         return cell
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
      // {
      //   dataField: "edit",
      //   text: `${this.props.t("Edit Data")}`,
      
      //   editable: true,

      //   editorRenderer: (
      //     editorProps,
      //     value,
      //     row,
      //     column,
      //     rowIndex,
      //     columnIndex
      //   ) => {
      //     return (
      //       <div className="btn-group">
      //         {!this.state.notEditableRows.includes(row.id) ? (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               this.setState({
      //                 notEditableRows: [...this.state.notEditableRows, row.id],
      //               });
      //             }}
      //           >
      //             <img src="images/dashboard-images/print.svg"></img>
      //           </span>
      //         ) : (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               if (
      //                 this.state.notEditableRows.length ===
      //                 this.state.stockList.length
      //               )
      //                 this.setState({
      //                   notEditableRows: this.state.notEditableRows.filter(
      //                     x => x != row.id
      //                   ),
      //                 });
      //             }}
      //           >
      //             <img src="images/dashboard-images/edit.svg"></img>
      //           </span>
      //         )}
      //         {/* <button
      //           className="bg-transparent border-0 ms-3"
      //           onClick={() => this.deleteRow(rowIndex)}
      //         >
      //           <img src="images/dashboard-images/deleteRow.svg"></img>
      //         </button> */}
      //       </div>
      //     );
      //   },
      //   formatter: (cell, row, rowIndex) => (
      //     <div className="btn-group">
      //       {!this.state.notEditableRows.includes(row.id) ? (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             this.setState({
      //               notEditableRows: [...this.state.notEditableRows, row.id],
      //             });
      //           }}
      //         >
      //           <img src="images/dashboard-images/print.svg"></img>
      //         </span>
      //       ) : (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             if (
      //               this.state.notEditableRows.length ===
      //               this.state.stockList.length
      //             )
      //               this.setState({
      //                 notEditableRows: this.state.notEditableRows.filter(
      //                   x => x != row.id
      //                 ),
      //               });
      //           }}
      //         >
      //           <img src="images/dashboard-images/edit.svg"></img>
      //         </span>
      //       )}
      //       {/* <button
      //         className="bg-transparent border-0 ms-3"
      //         onClick={() => this.deleteRow(rowIndex)}
      //       >
      //         <img src="images/dashboard-images/deleteRow.svg"></img>
      //       </button> */}
      //     </div>
      //   ),
      // },
    ];
    const defaultSorted = [
      {
        dataField: "srNo",
        order: "asc",
      },
    ];
  
    document.title = "grader flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Assign Screen")} />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={
                  this.state.props.isEdit == 1
                    ? {
                        partyCode:
                          this.state.props.data.mainJangad.party.partyCode,
                        id: this.state.props.data.mainJangad.id,
                        name: this.state.props.data.mainJangad.name,
                        category:
                          this.state.props.data.mainJangad.category.name,
                        fillerId: this.state.props.data.fillerId,
                        cycle: this.state.props.data.jangad.cycle,
                        remarks: this.state.props.data.remarks,
                        nextRemarks: this.state.props.data.nextRemarks,
                      }
                    : {
                        partyCode:
                          this.state.props.data.mainJangad.party.partyCode,
                        id: this.state.props.data.mainJangad.id,
                        name: this.state.props.data.mainJangad.name,
                        category:
                          this.state.props.data.mainJangad.category.name,
                        fillerId: this.state.props.data.fillerId,
                        cycle: this.state.props.data.cycle,
                        remarks: this.state.props.data.remarks,
                        nextRemarks: this.state.props.data.nextRemarks,
                      }
                }
                validationSchema={Yup.object().shape({
                  id: Yup.string(),
                  partyCode: Yup.string().required("This value is required"),
                  fillerId: Yup.string().required("This value is required"),
                  remarks: Yup.string()
                    .max(512)
                    .min(1)
                    .max(255)
                    .nullable()
                    .notRequired(),
                  nextremarks: Yup.string()
                    .max(512)
                    .min(1)
                    .max(255)
                    .nullable()
                    .notRequired(),
                })}
              >
                {({
                  errors,
                  status,
                  touched,
                  values,
                  isValid,
                  isValidating,
                  isSubmitting,
                  validateOnMount,
                  validateForm,
                  validateField,
                }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                              {this.props.t("Assign Screen")}
                            </h4>
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Assign Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>

                        <CardBody>
                          <Row>
                            {/* <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Jangad No')}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.id && touched.id
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="id"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="id"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div> */}
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Jangad No")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="name"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Party Code")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.partyCode && touched.partyCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="partyCode"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="partyCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="category"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Diamond Category")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.category && touched.category
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.data ? true : false
                                  }
                                  type="text"
                                  name="category"
                                  placeholder="20.25 CT"
                                />
                                <ErrorMessage
                                  name="category"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="fillerId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Filler Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.fillerId && touched.fillerId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  name="fillerId"
                                  as="select"
                                >
                                  <option value="">ALL</option>
                                  {this.state.fillerList?.map(x => (
                                    <option value={x.id} key={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="fillerId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="cycle"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Cycle No.")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.cycle && touched.cycle
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={true}
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="cycle"
                                  placeholder="cycle 1"
                                />
                                <ErrorMessage
                                  name="cycle"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="remarks"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Grader Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.remarks && touched.remarks
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  type="text"
                                  name="remarks"
                                  placeholder="Please Take of HPHT First Priority"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="remarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="nextRemarks"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Filler Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.nextRemarks && touched.nextRemarks
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  type="text"
                                  name="nextRemarks"
                                  placeholder="Please Take of HPHT First Priority"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="nextRemarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                          </Row>
                        </CardBody>
                      </div>
                      {this.state.props.isEdit == 3 ? (
                        ""
                      ) : (
                        <>
                          <div className="row px-3 pt-3">
                            <div className="d-flex justify-content-between">
                              <h3 className="fw-bold pb-3 text-black">
                                {this.props.t("Enter stock Details")}
                              </h3>
                              {/* <button
                            type="button"
                            className="bg-transparent border-0"
                            onClick={() => this.addRow()}
                          >
                            <img
                              src="images/dashboard-images/addRow.svg"
                              alt="add Row"
                            />
                          </button> */}
                            </div>

                            <div className="table-responsive">
                              <BootstrapTable
                                keyField="id"
                                classes="foo"
                                headerClasses="background-light fs-5"
                                footerClasses="background-light fs-5"
                                data={this.state.stockList}
                                columns={this.columns1}
                                defaultSorted={defaultSorted}
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                  // nonEditableRows: () =>
                                  //   this.state.notEditableRows,
                                  afterSaveCell:() => {
                                  this.setState({
                                    stockList: [...this.state.stockList]
                                  })
                                }
                                })}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            {this.props.t("Stock summary")}
                          </h3>
                        </div>

                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            defaultSorted={defaultSorted}
                            data={this.state.stockList}
                            columns={this.columns1}
                          />
                        </div>
                      </div>

                      <div className="col-md-12 text-center text-md-end pe-3 py-5">
                        {this.state.props.isEdit == 3 ? (
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={() => this.state.history.goBack()}
                          >
                            Back
                          </Button>
                        ) : (
                          <>
                            {this.state.successTrue ? (
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                                onClick={async () => {
                                  this.props.history.goBack();
                                }}
                              >
                                Back
                              </Button>
                            ) : (
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                                onClick={async () => {
                                  this.setState(
                                    { isSubmit: true },
                                    async () => {
                                      if (this.validateTable()) {
                                        await validateForm()
                                          .then(data => {
                                            if (Object.keys(data).length == 0) {
                                              this.handleSubmit(event, values);
                                            }
                                          })
                                          .catch(err =>
                                            console.log("err =>", err)
                                          );
                                      }
                                    }
                                  );
                                }}
                              >
                                {this.state.props.isEdit == 1
                                  ? "Assign"
                                  : "Update"}
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(GraderAssignScreen);
